import toast from "react-hot-toast";

import { MAX_FILE_SIZE, MAX_FILE_SIZE_MB } from "@/lib/constants/photos";
import { uploadEditorContentImage } from "@/lib/images";
import { api, handleApiRequest } from "@/lib/utils";

export function isFileValid(file: File, showAlert = true): boolean {
  if (!file) {
    if (showAlert) {
      toast.error("No file selected. Please select a file to upload.");
    }
    return false;
  }

  const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
  if (!allowedTypes.includes(file.type)) {
    if (showAlert) {
      toast.error("Invalid file type. Please select a JPEG, JPG, PNG, or WEBP image file.");
    }
    return false;
  }

  if (file.size > MAX_FILE_SIZE) {
    if (showAlert) {
      toast.error(`File size too large. Please select a file smaller than ${MAX_FILE_SIZE_MB}MB.`);
    }
    return false;
  }

  return true;
}

// bypasses the site photo library; uploads go client-side so large files avoid the vercel 4.5mb limit.
export const handleImageUpload = async (file: File, websiteId: string): Promise<string> => {
  if (file.size > MAX_FILE_SIZE) {
    throw new Error(`File size too large. Max file size is ${MAX_FILE_SIZE_MB}MB`);
  }

  return uploadEditorContentImage(file, websiteId);
};

export const handleImageDelete = async (id: string): Promise<string> => {
  try {
    let message = "";

    await handleApiRequest({
      makeRequest: async () => {
        const response = await api.delete("/api/uploads/photo", {
          data: { images: [{ providerId: id, source: "imagekit" }] },
        });

        message = response.data.message;
        return response.data;
      },
    } as Parameters<typeof handleApiRequest>[0]);

    return message;
  } catch (error) {
    throw error;
  }
};
